import { render, staticRenderFns } from "./BrandAnimationSection.vue?vue&type=template&id=53098148&scoped=true"
import script from "./BrandAnimationSection.vue?vue&type=script&lang=js"
export * from "./BrandAnimationSection.vue?vue&type=script&lang=js"
import style0 from "./BrandAnimationSection.vue?vue&type=style&index=0&id=53098148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53098148",
  null
  
)

export default component.exports